import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { TaxInputInf, TaxTypes } from "../../../interfaces/interfaces";
import { Field, Form } from "react-final-form";
import styles from './TaxInputForm.module.scss';
import Switch from "react-switch";
import { onBlurFormatNumber, parseNumberForDB } from "../../../components/functions/utilities";
import OutlinedFormInput from "../components/OutlinedFormInput/OutlinedFormInput";
import { MdInfo as InfoIcon } from 'react-icons/md'

type Props = {
    taxInputData: TaxInputInf
}

const gstApplicableCase = new Set([TaxTypes.fixed, TaxTypes.variable])


const TaxInputForm = forwardRef(({ taxInputData }: Props, ref) => {
    const [initialValues, setInitialValues] = useState({});
    const contentRef = useRef(null);
    const [formError, setFormError] = useState(false);
    const [allowTransition, setAllowTransition] = useState(false); // New state to control transitions

    const formRef = useRef(null);

    useEffect(() => {
        if (taxInputData) {
            setInitialValues({
                taxType: taxInputData.taxType,
                value: taxInputData.value,
            })
        } else {
            setInitialValues({
                taxType: TaxTypes.fixed,
                value: null,
            })
        }

        // After initial setup, enable transitions
        const timeout = setTimeout(() => {
            setAllowTransition(true);
        }, 100);

        return () => clearTimeout(timeout);

    }, []);

    useImperativeHandle(ref, () => ({
        submitTaxForm: () => {
            return new Promise((resolve) => {
                formRef.current.submit();
                console.log("pristing", formRef?.current)
                if (formError) {
                    resolve({ success: false, values: null, pristine: formRef?.current?.getState().pristine })
                } else {
                    resolve({ success: true, values: formRef?.current?.getState().values, pristine: formRef?.current?.getState().pristine })
                }
            })
        }
    }))

    const handleFormSubmit = (values) => {
        console.log('values', values);
        return values;
    }

    return (
        <Form
            initialValues={initialValues}
            onSubmit={handleFormSubmit}
            validate={(values) => {
                const errorValues = {};
                if (values?.taxType == TaxTypes.fixed && !values?.value) {
                    errorValues['value'] = 'Enter GST';
                    setFormError(true);
                } else if (values?.taxType == TaxTypes.fixed && values?.value && (values?.value < 0 || values?.value > 100)) {
                    errorValues['value'] = 'GST must be between 0 and 100';
                    setFormError(true);
                } else {
                    setFormError(false);
                }
                return errorValues;
            }}
            render={({ pristine, values, handleSubmit, form }) => {
                formRef.current = form;
                return (
                    <form style={{ width: "100%" }} onSubmit={handleSubmit}>
                        <div className={styles.inputTaxesRootContainer}>
                            <div ref={contentRef}
                                className={`${styles.fixedTaxRootContainer} ${!allowTransition ? styles.noTransition : ''} ${values?.taxType == TaxTypes.notApplicable ? styles.closed : ''}`}>
                                <div className={`${styles.fixedTaxContainer} ${values?.taxType == TaxTypes.variable ? styles.closed : ''}`}>
                                    <Field name="taxType">
                                        {(props) => (
                                            <div className={styles.switchRootContainer}>
                                                <div className={styles.fieldText}>
                                                    Is GST applicable on your products?
                                                </div>
                                                <div className={styles.switchContainer}>
                                                    <Switch
                                                        draggable={false}
                                                        disabled={false}
                                                        checked={gstApplicableCase.has(props.input.value)}
                                                        onChange={(checked) => {
                                                            // console.log('checked', checked)
                                                            // updateAccess(index, checked)
                                                            props.input.onChange(checked ? TaxTypes.fixed : TaxTypes.notApplicable)
                                                        }}
                                                        onColor="#100828"
                                                        offColor="#D5D5D5"
                                                        handleDiameter={20}
                                                        uncheckedIcon={false}
                                                        checkedIcon={false}
                                                        boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                                                        activeBoxShadow="0px 0px 1px 1px rgba(0, 0, 0, 0.2)"
                                                        height={24}
                                                        width={43}
                                                        className={styles.switch}
                                                        id="material-switch"
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </Field>
                                    <div className={styles.taxValueRootContainer}>

                                        <Field name="value">
                                            {(props) => {
                                                // console.log('value props', props)
                                                return (
                                                    <>
                                                        <div className={styles.taxValueFieldContainer}>
                                                            <div className={styles.taxValueInputContainer}>
                                                                <OutlinedFormInput
                                                                    {...props.input}
                                                                    showError={false}
                                                                    // placeholder="Enter GST"
                                                                    inpuType="number"
                                                                    name={props.input.name}
                                                                    value={props.input.value}
                                                                    onChange={(e) => {
                                                                        const numericValue = parseNumberForDB(e.target.value, true);
                                                                        props.input.onChange(numericValue);
                                                                    }}
                                                                    error={props.meta.error}
                                                                    touched={props.meta.touched}
                                                                    onBlur={(e) => {
                                                                        const value = props.input.value;
                                                                        console.log('value', value)
                                                                        const formattedValue = onBlurFormatNumber(value, 2);
                                                                        props.input.onChange(formattedValue);
                                                                        props.input.onBlur(e);
                                                                    }}
                                                                    unitPlaceHolder={"%"}
                                                                    unitPosition={"right"}
                                                                    maxLength={10}
                                                                    isCurrency={false}
                                                                    showBorder={true}
                                                                />
                                                            </div>
                                                            <div className={styles.taxValueText}>
                                                                of Net Sales Price
                                                            </div>
                                                        </div>
                                                        {props.meta.error && props.meta.touched ? <span className={styles.errorMessage}>{props.meta.error}</span> : null}
                                                    </>
                                                )
                                            }}
                                        </Field>
                                    </div>
                                </div>

                                <div className={`${styles.productTaxRootContainer} ${values?.taxType == TaxTypes.variable ? styles.open : ''}`}>
                                    <div className={styles.divider}></div>
                                    <div className={styles.switchRootContainer}>
                                        <div className={styles.fieldText}>
                                            Does every product have a different GST Rate?
                                        </div>
                                        <div className={styles.switchContainer}>
                                            <Switch
                                                draggable={false}
                                                disabled={false}
                                                checked={values?.taxType === TaxTypes.variable}
                                                onChange={(checked) => {
                                                    form.change("taxType", checked ? TaxTypes.variable : TaxTypes.fixed)
                                                }}
                                                onColor="#100828"
                                                offColor="#D5D5D5"
                                                handleDiameter={20}
                                                uncheckedIcon={false}
                                                checkedIcon={false}
                                                boxShadow="0px 1px 3px rgba(0, 0, 0, 0.6)"
                                                activeBoxShadow="0px 0px 1px 1px rgba(0, 0, 0, 0.2)"
                                                height={24}
                                                width={43}
                                                className={styles.switch}
                                                id="material-switch"
                                            />
                                        </div>
                                    </div>
                                    <div className={styles.productTaxBanner}>
                                        <InfoIcon />
                                        <div className={styles.textContainer}>
                                            Add GST for every product in the Product Costs section.
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </form>
                )
            }}
        />
    );
});

export default TaxInputForm;